import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { useAdvertisers } from '@/api/ads/hooks';
import { ResourceGate } from '@/features/ResourceGate';
import { PageHeader } from '@/components/PageHeader';
import { Card, CardBody } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Table, Th, Td, EmptyRow } from '@/components/ui/table';
import { Spinner } from '@/components/ui/spinner';
import { npr } from '@/lib/format';

export function AdvertisersPage() {
  const [q, setQ] = useState('');
  const { data, isLoading } = useAdvertisers(q || undefined);

  return (
    <ResourceGate slug="ads.advertisers">
      <PageHeader title="Advertisers" description="All advertiser accounts and wallet balances." />
      <div className="mb-4 flex max-w-sm items-center gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input className="pl-8" placeholder="Search advertisers…" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
      </div>
      <Card>
        <CardBody className="p-0">
          {isLoading ? (
            <div className="p-6">
              <Spinner label="Loading advertisers…" />
            </div>
          ) : (
            <Table>
              <thead>
                <tr>
                  <Th>Name</Th>
                  <Th>Company</Th>
                  <Th>Campaigns</Th>
                  <Th>Wallet</Th>
                  <Th>Status</Th>
                  <Th />
                </tr>
              </thead>
              <tbody>
                {(data?.results.length ?? 0) === 0 && <EmptyRow colSpan={6}>No advertisers found.</EmptyRow>}
                {data?.results.map((a) => (
                  <tr key={a.id}>
                    <Td className="font-medium">{a.name}</Td>
                    <Td className="text-muted-foreground">{a.company || '—'}</Td>
                    <Td>{a.campaigns_count}</Td>
                    <Td>{a.wallet ? npr(a.wallet.balance) : '—'}</Td>
                    <Td>
                      <Badge status={a.status}>{a.status}</Badge>
                    </Td>
                    <Td className="text-right">
                      <Link to={`/admin/advertisers/${a.id}`}>
                        <Button variant="outline" size="sm">
                          View
                        </Button>
                      </Link>
                    </Td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </CardBody>
      </Card>
    </ResourceGate>
  );
}
